import {FC, SVGProps} from 'react';

export const DocumentsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M19 2V9H26L19 2Z" fill="black" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M17.1111 2V11H26V30H6V2H17.1111ZM9 16H23V18H9V16ZM23 21H9V23H23V21Z"
			fill="black"
		/>
	</svg>
);
